import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// function testUrl(params) {
//   let curIp = {
//     websocket: '',
//     baseUrl: ''
//   }
//   if (
//     params.indexOf(':') != -1 &&
//     (/^192./.test(params) || /^10./.test(params) || /^127./.test(params) || /^localhost/.test(params))
//   ) {
//     let ip = params.split(':')[0]
//     curIp.websocket = ip + ':99'
//     curIp.baseUrl = 'http://' + ip + '/'
//   } else {
//     console.log('不是本地ip')
//   }

//   return curIp
// }
function testUrl(params) {
  let curIp = {
    websocket: '',
    baseUrl: ''
  }
  //http://172.16.9.168:18087
  //http://172.16.9.168:18088
  //http://172.16.9.168:18089
  if (params.indexOf('hd.cnimagecloud.cn') >= 0 || params.indexOf('hd.fjzkcloud.cn') >= 0 || params.indexOf('hd.cnimagecloud.com') >= 0 || params.indexOf('101.28.246') >= 0) {
    // curIp.websocket = '101.28.246.252:99'
    // curIp.baseUrl = 'http://101.28.246.252/'
    curIp.websocket = 'wss://hdwebsocket.fjzkcloud.cn'
    curIp.baseUrl = 'https://hdcloudback.fjzkcloud.cn/'
  }else if( params.indexOf('122.112.173.252') >= 0 ){
    curIp.websocket = '122.112.173.252:18088'
    curIp.baseUrl = 'http://122.112.173.252:18089/'
  }
  else if( params.indexOf('172.16.9.168') >= 0 ){
    curIp.websocket = '172.16.9.168:18088'
    curIp.baseUrl = 'http://172.16.9.168:18089/'
  }else if( params.indexOf('122.112.240.27') >= 0 ){
    curIp.websocket = '122.112.240.27:18088'
    curIp.baseUrl = 'http://122.112.240.27:503/'
  } else if( params.indexOf('172.16.6') >= 0 ){
    curIp.websocket = '172.16.9.168:18088'
    curIp.baseUrl = 'http://172.16.9.168:18089/'
  } else {
    // console.log('不是本地ip')
    var ip = params.split(":")[0]
    curIp.baseUrl = 'http://' + ip + ':18099/'
    curIp.websocket ='ws://' + ip + ':18098'
    // curIp.websocket = ip + ':99'
    // if (ip.indexOf("10.10.") == 0) {
    //   curIp.baseUrl = 'http://'+'10.10'+'.3.4/'
    //   curIp.websocket = '10.10'+'.3.4'+ ':99'
    // } else {
    //   curIp.baseUrl = 'http://' + ip + ':81/'
    // }
    // curIp.websocket = '101.28.246.229:99'
    // curIp.baseUrl = 'http://122.112.173.252:18089/' //测试
    // curIp.websocket = 'ws://122.112.173.252:18088/websocket/hdCloudSocketServer' //测试
  }

  return curIp
}

let host = window.location.host
let curIp = testUrl(host)

export default new Vuex.Store({
  state: {
    docNames: true,
    curIp: curIp
  },
  mutations: {
    setCurIp(state, params) {
      /**
       * 判断地址是否是 带冒号 且 为 192. 或者 10. 开头
       */
      // state.curIp = params
    }
  },
  actions: {
    setCurIpFun(context, params) {
      context.commit('setCurIp', params)
    }
  }
})